import React from 'react';
import { Box, Button, Container, Heading, Image, List, ListIcon, ListItem, SimpleGrid, Text, VStack } from '@chakra-ui/react';
import { CheckIcon } from 'lucide-react';
import { WhatsAppIcon } from './WhatsAppIcon';
import { images, whatsappHref } from '../data/brand';
const points = ['Conversamos contigo antes de iniciar cualquier práctica.', 'Te explicamos con claridad en qué consiste cada servicio.', 'Cada consulta se adapta a tu situación particular.'];
export function About() {
  return <Box as="section" id="nosotros" bg="cream.50" py={{
    base: 14,
    md: 24
  }} data-id="element-17" data-mp="38p1jw0pxuts2">
      <Container maxW="76rem" px={{
      base: 4,
      md: 6
    }} data-id="element-18" data-mp="3dgt3tsela198">
        <SimpleGrid columns={{
        base: 1,
        lg: 2
      }} spacing={{
        base: 10,
        lg: 16
      }} alignItems="center" data-id="element-19" data-mp="3djfbrt5e6irz">
          <Box position="relative" order={{
          base: 1,
          lg: 0
        }} data-id="element-20" data-mp="3hkhbeb380wuh">
            <Box position="absolute" top={{
            base: '-0.75rem',
            md: '-1rem'
          }} left={{
            base: '-0.75rem',
            md: '-1rem'
          }} right={{
            base: '0.75rem',
            md: '1rem'
          }} bottom={{
            base: '0.75rem',
            md: '1rem'
          }} border="1px solid" borderColor="gold.300" borderRadius="xl" aria-hidden="true" data-id="element-21" data-mp="3mjaq26u8utw8" />
            <Image src={images.about} alt="Mesa de consulta con una vela encendida, cristales de amatista y hierbas secas" borderRadius="xl" w="100%" maxH={{
            base: '22rem',
            lg: '32rem'
          }} objectFit="cover" position="relative" loading="lazy" data-id="element-22" data-mp="2csn3pgfomgk0" />
          </Box>

          <VStack align="flex-start" spacing={5} data-id="element-23" data-mp="2vnu26rypor3e">
            <Text fontSize="xs" fontWeight={600} letterSpacing="0.24em" textTransform="uppercase" color="gold.600" data-id="element-24" data-mp="2qqk0acu4ymyo">
              Templo de Ayuda Esotérica
            </Text>
            <Heading as="h2" fontSize={{
            base: '1.75rem',
            md: '2.5rem'
          }} color="plum.800" data-id="element-25" data-mp="3jdodh53du7lj">
              ACERCA DE NOSOTROS
            </Heading>
            <Box w="3.5rem" h="1px" bg="gold.400" data-id="element-26" data-mp="b5gbksyvhyqb" />
            <Text fontSize={{
            base: 'md',
            md: 'lg'
          }} color="plum.600" data-id="element-27" data-mp="b457st5fgqz7">
              Contamos con experiencia en servicios y prácticas esotéricas tradicionales. Nuestro
              objetivo es ofrecer orientación personalizada y atención cercana a cada persona que nos
              consulta.
            </Text>
            <List spacing={3} pt={1} data-id="element-28" data-mp="3jn330zauogl6">
              {points.map(point => <ListItem key={point} display="flex" alignItems="flex-start" fontSize="md" color="plum.700" data-id="element-29" data-mp="3ol4mhlc6uhx6">
                  <ListIcon as={CheckIcon} color="gold.600" mt="0.35rem" data-id="element-30" data-mp="3am4y8esl851j" />
                  <Text as="span" data-id="element-31" data-mp="3em5lmoxnzqkq">{point}</Text>
                </ListItem>)}
            </List>
            <Button as="a" href={whatsappHref('una consulta personalizada')} target="_blank" rel="noopener noreferrer" variant="whatsapp" size="lg" h="3.25rem" px={7} fontSize="sm" w={{
            base: '100%',
            sm: 'auto'
          }} leftIcon={<WhatsAppIcon size={19} data-id="element-33" data-mp="372e4p2x1pr8g" />} data-id="element-32" data-mp="18tgpjpx6cped">
              CONSULTAR POR WHATSAPP
            </Button>
          </VStack>
        </SimpleGrid>
      </Container>
    </Box>;
}